import { LoaderCircle } from "lucide-react";
import { createElement, ElementType, FC } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type Props = {
  title: string;
  value?: string | number;
  icon: ElementType;
  isLoading?: boolean;
};

export const Metric: FC<Props> = ({
  title,
  value,
  icon,
  isLoading = false,
}) => {
  const glyph = createElement(icon, {
    className: "w-4 h-4",
    stroke: "var(--muted-foreground)",
    absoluteStrokeWidth: 1.33,
  });

  return (
    <Card className="flex-1 p-6 space-y-6">
      <CardHeader className="p-0">
        <CardTitle className="flex justify-between items-center">
          <span>{title}</span>
          <span>{glyph}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <div className="min-h-[2.5rem] flex items-center font-medium text-2xl/tight">
          {isLoading ? (
            <LoaderCircle className="h-5 w-5 animate-spin text-muted-foreground" />
          ) : (
            value
          )}
        </div>
      </CardContent>
    </Card>
  );
};
